export { usePostTinApi, resetPostTinManagement } from './usePostTinApi';
export { reducerPostTinApi } from './reducerPostTinApi';
